import { useEffect } from 'react'
import { Overlay, Dialog, Body, Footer } from '../styles/RejectConfirmationModalStyle'

interface ConfirmSendMoneyModalProps {
  open: boolean
  amount: string
  recipientCount: number | string
  onClose: () => void
  onConfirm: () => void
}

export default function ConfirmSendMoneyModal({ open, amount, recipientCount, onClose, onConfirm }: ConfirmSendMoneyModalProps) {
  useEffect(() => {
    function esc(e: KeyboardEvent) { if (e.key === 'Escape') onClose() }
    if (open) window.addEventListener('keydown', esc)
    return () => window.removeEventListener('keydown', esc)
  }, [open, onClose])

  if (!open) return null

  return (
    <Overlay onClick={onClose}>
      <Dialog role='dialog' aria-modal='true' onClick={e => e.stopPropagation()} style={{ maxWidth: '400px' }}>
        <Body>
          <h3 className='text-lg font-semibold mb-2'>Confirm Send Money</h3>
          <p className='text-sm text-[#6D6D72]'>
            Are you sure you want to send {amount} to {recipientCount === 'All' ? 'all users' : `${recipientCount} user${Number(recipientCount) > 1 ? 's' : ''}`}?
          </p>
        </Body>
        <Footer>
          <button className='cancel' onClick={onClose}>Cancel</button>
          <button className='reject' onClick={onConfirm}>Confirm</button>
        </Footer>
      </Dialog>
    </Overlay>
  )
}
